import React, { createContext, useContext, useReducer } from 'react';

import {
    configReducer,
    ConfigActions,
    configReducerProps,
    configReducerInitialState,
    configReducerInit
} from '..';

interface ConfigContextProps extends configReducerProps {
    state: configReducerProps;
    dispatch: React.Dispatch<ConfigActions>;
}

export const ConfigContext = createContext<ConfigContextProps>({
    ...configReducerInitialState,
    state: configReducerInitialState,
    dispatch: () => null
});
export const useConfig = () => useContext(ConfigContext);

export const ConfigContextProvider: React.FC<{ children: React.ReactNode }> = ({
    children
}) => {
    const [state, dispatch] = useReducer(
        configReducer,
        configReducerInitialState,
        configReducerInit
    );
    return (
        <ConfigContext.Provider value={{ ...state, state, dispatch }}>
            {children}
        </ConfigContext.Provider>
    );
};
